import BadgePermissionsCount from '../BadgePermissionsCount';
import { useFormContext, useWatch } from 'react-hook-form';
import { BadgeUserInfo } from '@/components/custom';
import { IEmployee } from '@/interfaces';
import { cn } from '@/lib/utils';
import { TFormData } from '.';

type TProps = {
  employee: IEmployee;
}

const FormEditOrAssignPermissionsBodyUsersItem = ({ employee }: TProps) => {

  const { control, setValue } = useFormContext<TFormData>();
  let selectedEmployeeId = useWatch({ control, name: 'selectedEmployeeId' });

  const handleOnClickElement = () => {
    setValue('selectedEmployeeId', employee?._id);
    setValue('roles', employee.roles);
  };

  return (
    <div
      role='button'
      onClick={handleOnClickElement}
      className={cn(
        'px-3 py-1.5 mb-1 rounded-md',
        'flex flex-row items-center justify-between',
        'hover:bg-muted',
        selectedEmployeeId === employee._id &&
        'bg-purple-200 border-purple-300 border'
      )}>
      <BadgeUserInfo
        email={employee.email}
        username={employee.username} />
      <BadgePermissionsCount employee={employee} />
    </div>
  );

};

export default FormEditOrAssignPermissionsBodyUsersItem;
